/* embla-loop.js — one infinite Embla setup for every carousel (owner 2026-09-25: "infinite, like the KP-10
   before/after carousel"; Embla loop:true, drag/swipe, dots, optional arrows; never auto-drift).
   Same engine + options as dlx-before-after (loop:true, dragFree:false) and embla-kp.js (gap -> margin seam fix).

   Markup contract (add to an existing slider, keep its own look):
     <div data-el data-el-align="start|center" data-el-dot-on="on">   root
       <div data-el-viewport> <div data-el-container> slide slide ... </div> </div>
       <button data-el-prev></button> <button data-el-next></button>        optional
       <div data-el-dots> <button data-el-dot></button> ... </div>          optional; generated if empty
     </div>
   The section's own dot styling is kept: the active dot gets the class in data-el-dot-on (default "on").
   Generated dots copy data-el-dot-class onto each button. */
(function () {
  var CDN = 'https://cdn.jsdelivr.net/npm/embla-carousel@8/embla-carousel.umd.js';
  var loading = null;
  function load() {
    if (window.EmblaCarousel) return Promise.resolve();
    if (loading) return loading;
    loading = new Promise(function (res, rej) {
      var tries = 0;
      (function wait() {                     /* the theme usually loads Embla itself; give it a moment */
        if (window.EmblaCarousel) return res();
        if (++tries > 15) {
          var s = document.createElement('script'); s.src = CDN; s.async = true;
          s.onload = function () { window.EmblaCarousel ? res() : rej(); }; s.onerror = rej;
          document.head.appendChild(s); return;
        }
        setTimeout(wait, 200);
      })();
    });
    return loading;
  }

  function seamFix(container) {             /* CSS gap does not travel with looped slides; margins do */
    if (container.__elGap) return; container.__elGap = true;
    var cs = getComputedStyle(container), gap = parseFloat(cs.columnGap || cs.gap || '0') || 0;
    if (!gap) return;
    container.style.gap = '0px'; container.style.columnGap = '0px';
    for (var i = 0; i < container.children.length; i++) container.children[i].style.marginRight = gap + 'px';
  }

  function init(root) {
    if (root.__el) return;
    var vp = root.querySelector('[data-el-viewport]'), ct = root.querySelector('[data-el-container]');
    if (!vp || !ct || ct.children.length < 2) return;
    if (vp.offsetParent === null) {          /* hidden (e.g. the mobile slider on desktop): init when shown */
      if (!root.__elWait) { root.__elWait = true; window.addEventListener('resize', function () { init(root); }); }
      return;
    }
    root.__el = true;
    seamFix(ct);
    vp.style.setProperty('overflow', 'hidden', 'important'); vp.style.setProperty('scroll-snap-type', 'none', 'important');
    if (getComputedStyle(vp).position === 'static') vp.style.position = 'relative';   /* Embla measures offsets from the viewport */
    ct.style.transition = 'none'; ct.style.transform = '';                         /* old hand-rolled sliders animate transform */
    ct.style.touchAction = 'pan-y pinch-zoom';
    /* Embla can only loop when the row is wider than the screen plus a card; short rows (2-3 cards)
       get aria-hidden copies so they still wrap. Dots always count the real cards. */
    var real = ct.children.length, w = function () { var s = 0; for (var k = 0; k < ct.children.length; k++) s += ct.children[k].getBoundingClientRect().width + (parseFloat(getComputedStyle(ct.children[k]).marginRight) || 0); return s; };
    for (var rounds = 0; rounds < 4 && w() < vp.clientWidth * 2 + 40; rounds++) {
      for (var k = 0; k < real; k++) {
        var cl = ct.children[k].cloneNode(true); cl.setAttribute('aria-hidden', 'true'); cl.setAttribute('data-el-clone', '');
        [].forEach.call(cl.querySelectorAll('a,button,input,video'), function (x) { x.setAttribute('tabindex', '-1'); });
        ct.appendChild(cl);
      }
    }
    if (ct.children.length > real) document.dispatchEvent(new CustomEvent('el:cloned', { detail: ct }));
    var on = root.getAttribute('data-el-dot-on') || 'on';
    var embla = window.EmblaCarousel(vp, { loop: true, align: root.getAttribute('data-el-align') || 'start', dragFree: false, skipSnaps: false });
    var snapsPerReal = embla.scrollSnapList().length / (ct.children.length / real);
    var box = root.querySelector('[data-el-dots]'), dots = [].slice.call(root.querySelectorAll('[data-el-dot]'));
    if (box && !dots.length) {
      var cls = root.getAttribute('data-el-dot-class') || '';
      embla.scrollSnapList().slice(0, Math.round(snapsPerReal)).forEach(function (_, i) {
        var b = document.createElement('button'); b.type = 'button'; b.className = cls; b.setAttribute('data-el-dot', '');
        b.setAttribute('aria-label', 'Slide ' + (i + 1)); box.appendChild(b);
      });
      dots = [].slice.call(root.querySelectorAll('[data-el-dot]'));
    }
    var nd = dots.length || 1;
    dots.forEach(function (d, i) { d.addEventListener('click', function (e) {    /* nearest copy of card i */
      e.preventDefault(); var cur = embla.selectedScrollSnap(), total = embla.scrollSnapList().length, best = i, bd = 1e9;
      for (var t = i; t < total; t += nd) { var dd = Math.min(Math.abs(t - cur), total - Math.abs(t - cur)); if (dd < bd) { bd = dd; best = t; } }
      embla.scrollTo(best); }); });
    function sel() { var i = embla.selectedScrollSnap() % nd; dots.forEach(function (d, j) { d.classList.toggle(on, i === j); d.setAttribute('aria-current', i === j ? 'true' : 'false'); }); }
    embla.on('select', sel); embla.on('reInit', sel); sel();
    var p = root.querySelector('[data-el-prev]'), n = root.querySelector('[data-el-next]');
    if (p) p.addEventListener('click', function (e) { e.preventDefault(); embla.scrollPrev(); });
    if (n) n.addEventListener('click', function (e) { e.preventDefault(); embla.scrollNext(); });
    [].forEach.call(ct.querySelectorAll('img'), function (img) { if (!img.complete) img.addEventListener('load', function () { embla.reInit(); }, { once: true }); });
    root.__embla = embla;
  }

  function all() {
    var roots = document.querySelectorAll('[data-el]'); if (!roots.length) return;
    load().then(function () { [].forEach.call(roots, init); }).catch(function () {});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  document.addEventListener('shopify:section:load', all);
})();
